import { useEffect, useCallback, useRef } from 'react';
import { debounce } from 'lodash';
import { useNoteSchemaContext } from '../contexts';
import { useFlagEnabled } from 'flagging/hooks';
import { useFlagValue } from 'flagging/hooks';
export var useAutoSave = function (saveDraft, signed, formInitialized, canI) {
    var schemaInitialized = useRef(false);
    var onLoadInitialized = useRef(false);
    var autosaveDebounceValue = useFlagValue('AUTOSAVE_DEBOUNCE_VALUE');
    var autosaveEnabled = useFlagEnabled('ENABLE_AUTOSAVE');
    var _a = useNoteSchemaContext(), form = _a.form, schema = _a.schema, noteType = _a.noteType;
    var debouncedAutosave = useCallback(debounce(function (saveDraft) {
        if (autosaveEnabled && canI) {
            saveDraft();
        }
    }, autosaveDebounceValue), []);
    useEffect(function () {
        /**
         * This is an ugly way of skipping initial load, but controlled components (ie datepicker) seem able to dirty the form immediately.
         * Without doing explicit checks against those values initial settings, (which would require keeping a list of them populated),
         * there's probably not a better way than just giving them a moment to sort themselves out
         */
        if (formInitialized) {
            setTimeout(function () {
                onLoadInitialized.current = true;
            }, 200);
        }
    }, [formInitialized]);
    useEffect(function () {
        var subscription = form.watch(function () {
            if (schema && schemaInitialized.current && onLoadInitialized.current && !signed) {
                debouncedAutosave(saveDraft);
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [noteType, schema, form, saveDraft]);
    useEffect(function () {
        if (schema) {
            if (schemaInitialized.current && onLoadInitialized.current && !signed) {
                debouncedAutosave(saveDraft);
            }
            else {
                schemaInitialized.current = true;
            }
        }
    }, [schema]);
    return { debouncedAutosave: debouncedAutosave };
};
